<template>
    <el-dialog
        ref="dialogRef"
        :title="'打印预览'"
        :width="'900px'"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :before-close="beforeClose"
        :custom-class="'printPreviewDialog'"
        top="5vh"
    >
        <div slot="title">
            <span>打印预览</span>
            <span class="template mgl-14">模板名称：{{ currentPrintData.templateName }} / </span>
            <span class="template">模板编码：{{ currentPrintData.templateCode }}</span>
        </div>
        <div v-loading="dialogLoading">
            <div class="content-title">
                <span class="content-title-block"></span>
                <span class="content-txt">命中情况</span>
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content" v-html="'自识别打印支持从客户订单号维度打印；<br/>自识别打印仅打印命中的客户订单，未命中的客户订单不予打印。'"></div>
                    <i class="el-icon-question"></i>
                </el-tooltip>
            </div>
            <virtual-table
                ref="matchTable"
                border
                :columns="matchConfig.columns"
                :height="matchConfig.height"
                :size="matchConfig.size"
                :actions="matchConfig.action"
                :rows="matchData"
                :customCellStyle="cellStyle"
                @cell-dblclick="handleDblclick"
            ></virtual-table>
            <el-collapse v-model="isShowMatchRule">
                <el-collapse-item name="rule">
                    <template slot="title">
                        <div class="second-title">命中规则</div>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content" v-html="'每个模板可打印的客户订单可参考本命中规则；<br/>命中规则可在打印模板配置中进行配置。'"></div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <virtual-table
                        ref="matchRuleTable"
                        border
                        :columns="matchRuleConfig.columns"
                        :height="matchRuleConfig.height"
                        :size="matchRuleConfig.size"
                        :actions="matchRuleConfig.action"
                        :rows="matchRule"
                    ></virtual-table>
                </el-collapse-item>
            </el-collapse>
            <div class="content-title mgt-10">
                <span class="content-title-block"></span>
                <span class="content-txt">样图预览</span>
            </div>
            <div class="img-wrapper">
                <imgShow ref="previewImg" v-if="attachmentList && attachmentList.length" :imgArr="attachmentList"></imgShow>
                <div v-else>暂无样图信息</div>
            </div>
            <el-collapse v-model="isShowContent">
                <el-collapse-item name="content">
                    <template slot="title">
                        <div class="second-title">模板内容</div>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content" v-html="'该模板的具体内容，以及取值逻辑。'"></div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <div class="template-content" v-if="templateContent">{{ templateContent }}</div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </el-dialog>
</template>

<script>
import { queryMatchDetail, queryMatchRules, queryTemplateDetail } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import { matchConfig, matchRuleConfig } from './config.js';
import { formatMatchData, formatMatchRule, copyToClip } from './util.js';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    name: 'DispatchPrintPreview',
    components: {
        virtualTable: () => import('./components/virtualTable'),
        imgShow: () => import('./components/imgShow')
    },
    props: {
        isShowPrintPreviewDialog: {
            type: Boolean,
            default () {
                return false;
            }
        },
        currentPrintData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            visible: false,
            dialogLoading: false,
            isShowMatchRule: '',
            isShowContent: '',
            matchData: [],
            matchRule: [],
            matchConfig,
            matchRuleConfig,
            templateContent: '',
            attachmentList: []
        };
    },
    async mounted () {
        await this.getDicData();
        await this.initData();
        this.visible = true;
    },
    methods: {
        initData () {
            this.dialogLoading = true;
            Promise.all([
                this.queryMatchDetail(),
                this.queryMatchRules(),
                this.queryTemplateDetail()
            ])
                .catch(() => { })
                .finally(() => {
                    this.dialogLoading = false;
                });
        },
        queryMatchDetail () {
            queryMatchDetail({
                dispatchNoList: this.currentPrintData.dispatchNoList,
                templateCode: this.currentPrintData.templateCode
            }).then(res => {
                if (res && +res.code === 0) {
                    this.matchData = formatMatchData(res.data || [], this.dictData);
                }
            }).catch(() => { });
        },
        queryMatchRules () {
            queryMatchRules({
                templateCode: this.currentPrintData.templateCode
            }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.matchRule = formatMatchRule(res.data.ruleList || [], this.dictData);
                }
            }).catch(() => { });
        },
        queryTemplateDetail () {
            queryTemplateDetail({
                templateCode: this.currentPrintData.templateCode
            }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.attachmentList = res.data.samplePicInfoList || [];
                    this.templateContent = res.data.templateContent || '';
                }
            }).catch(() => { });
        },
        handleDblclick (row, column) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        },
        cellStyle ({ row, column }) {
            if (column.property === 'matchStatusName') {
                if (row.matchStatus === '1') {
                    return { 'color': 'red' };
                } else if (row.matchStatus === '2') {
                    return { 'color': '#00BCBF' };
                } else {}
            }
        },
        beforeClose () {
            this.$emit('update:isShowPrintPreviewDialog', false);
        },
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'MATCH_STATUS,SYS_PROFESSIONAL_COMPANY,BUSINESS_MODE,ORDER_TYPE,DELIVERY_TYPE,TASK_TYPE,DISTRIBUTION_FLAG,DISTRIBUTION_LAST_FLAG'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style lang="less">
@import url('./style/index.less');
</style>
